
import app from "./app";
import pagination from "./pagination";
import actionDetails from "./action-details";

export default {
  ...app,
  ...pagination,
  ...actionDetails,
};
